"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPwaLaunched = void 0;
const isPwaLaunched = () => {
    let displayMode = 'web';
    const mqStandAlone = '(display-mode: standalone)';
    if (navigator.standalone || window.matchMedia(mqStandAlone).matches) {
        displayMode = 'pwa';
        return displayMode;
    }
    return displayMode;
};
exports.isPwaLaunched = isPwaLaunched;
